import React, { useCallback, useRef } from 'react';
import { Breakpoints, Button, intl, Select, useBreakpoint } from 'ehs-react';
import type { at } from '../generated/Beans';
import { useLoginCredentialsStore } from '../stores/loginCredentials.store';

type HPDParentComboBean = at.sense.hooks.login.hpd.HPDParentComboBean;

export type HpdSelectionAreaParameters = {
  onSubmit: (company: HPDParentComboBean) => void;
};
export function HpdSelectionArea({
  onSubmit
}: Readonly<HpdSelectionAreaParameters>): React.JSX.Element {
  const [
    viewState,
    availableHpdCompanies,
    selectedHpdCompany,
    setSelectedHpdCompany
  ] = useLoginCredentialsStore(state => [
    state.viewState,
    state.availableHpdCompanies,
    state.selectedHpdCompany,
    state.setSelectedHpdCompany
  ]);

  const isMobile = useBreakpoint(Breakpoints.MOBILE);

  const submitHandler = useCallback(() => {
    if (selectedHpdCompany) {
      onSubmit(selectedHpdCompany);
    }
  }, [onSubmit, selectedHpdCompany]);

  const container = useRef<HTMLDivElement>(null);

  if (availableHpdCompanies.length <= 1 || viewState !== 'HPD_SELECTION') {
    return <></>;
  }

  return (
    <div className="hpd-selection-area progress-card-react" ref={container}>
      <p className="font-16 s-font"> {intl('loginhook.hpd.view')} </p>
      <Select<HPDParentComboBean>
        tooltipContainerRef={container}
        variant="single"
        hideClearIcon={true}
        label={intl('common.institution')}
        items={availableHpdCompanies}
        itemValueProp="oid"
        itemLabelProp="name"
        value={selectedHpdCompany || null}
        onChange={selectedHpdEntry =>
          selectedHpdEntry && setSelectedHpdCompany(selectedHpdEntry)
        }
        autoFocus={true}
      />
      <div className={`content-button-bar ${isMobile ? 'mobile' : ''}`}>
        <Button
          variant="primary"
          text={intl('view.button.next')}
          onClick={submitHandler}
        />
      </div>
    </div>
  );
}
